// Copyright The Linux Foundation and each contributor to LFX.
// SPDX-License-Identifier: MIT
import { Directive, ViewContainerRef, TemplateRef, AfterViewInit, OnDestroy } from '@angular/core';
import { LoggedUserService } from '../services/logged-user.service';
import { take, takeUntil } from 'rxjs/operators';
import { Subject } from 'rxjs';

@Directive({
  // tslint:disable-next-line:directive-selector
  selector: '[loadAfterUser]'
})
export class LoadAfterUserDirective implements OnDestroy {
  _currentUser$ = this.loggedUserService.loggedUser$;
  _destroy$ = new Subject();
  constructor(
    private vc: ViewContainerRef,
    private tpl: TemplateRef<any>,
    private loggedUserService: LoggedUserService
  ) {
    this.vc.createEmbeddedView(this.tpl);

    this._currentUser$.pipe(takeUntil(this._destroy$)).subscribe(() => {
      this.vc.clear();
      this.vc.createEmbeddedView(this.tpl);
    });
  }
  ngOnDestroy(): void {
    this._destroy$.next();
    this._destroy$.unsubscribe();
  }
}



// WEBPACK FOOTER //
// ./src/app/core/directives/load-after-user.directive.ts